type PropsImageSvg = {
  src: string; // src do arquivo svg (ex: 'carro.svg')
  className?: string;
  alt?: string; // opcional para acessibilidade
};

const ImageSvg: React.FC<PropsImageSvg> = ({
  src,
  className = "",
  alt = "",
}) => {
  const caminho = `/vector/${src}`;

  return <img src={caminho} className={className} alt={alt} />;
};

export default ImageSvg;
